export const CASHIER_OPEN = 'CASHIER_OPEN';
export const CASHIER_CLOSE = 'CASHIER_CLOSE';
